import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { ButtonClose } from '@shared/ui'

// Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'StocksModal',
  props: {
  titleModal: {
    type: String as PropType<string>,
    required: true,
    default: ''
  },
  descriptionModal: {
    type: String as PropType<string>,
    required: true,
    default: ''
  }
},
  emits: ['closeModal'],
  setup(__props, { emit }) {

const props = __props



// Props


return { __sfc: true,emit, props, ButtonClose }
}

})